import React, { Dispatch, useEffect, useState } from 'react'
import Link from '../../../components/link/Link'
import { FormattedMessage, useIntl } from 'react-intl'
import styles from '../../../styles'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Exploitation from '../../../components/news/Exploitation'
import fetchFactory from '../../../utils/fetchFactory'
import { NewsExploitationModel, NewsMarketingModel, NewsModel } from '../../../types/news/newsModel'
import errorCatcher from '../../../utils/errorCatcher'
import { connect, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { saveNews, setLoadingNews } from '../../reducers/news/actions'
import { NewsType } from '../../reducers/news/types'
import Loader from '../../../components/loader/Loader'
import Marketing from '../../../components/news/Marketing'
import EmptyState from '../../../components/news/EmptyState'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'
import { newsEnum } from '../../../enums/newsEnum'
import { ClassValue } from 'classnames/types'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            headerNewsStyle: {
                marginBottom: 25,

                '& h1': {
                    color: theme.palette.blue.main
                }
            },
            linkStyle: {
                display: 'flex',
                flexDirection: 'row-reverse'
            }
        }
    )
)

const COMPONENT_NAME = 'dashboard_news'

const News = () => {
    const classes = useStyle()
    const history = useHistory()
    const intl = useIntl()
    const dispatch = useDispatch()
    const news = useSelector((state: RootState) => state.news)
    const [filteredNewsExploitations, setFilteredNewsExploitation] = useState<NewsExploitationModel[]>([])
    const [filteredNewsMarketing, setFilteredNewsMarketing] = useState<NewsMarketingModel[]>([])

    const headerNewsClass: ClassValue = classNames(
        'row',
        classes.flexBetween,
        classes.alignCenter,
        classes.headerNewsStyle
    )

    const linkAllClass: ClassValue = classNames(
        'col-xs-12 col-sm-6',
        classes.linkStyle
    )

    const filterNews = (type: newsEnum, news: any) => {
        if (type === newsEnum.actualite_exploitation) {
            const tmpNewsExploitation: NewsExploitationModel[] = news.filter(
                (exploitation: NewsExploitationModel) => (
                    exploitation.is_published === '1' && new Date() <= new Date(exploitation.end_publication)
                )
            )

            if (tmpNewsExploitation.length > 0) {
                setFilteredNewsExploitation(tmpNewsExploitation.slice(0, 2))
            } else {
                setFilteredNewsExploitation([])
            }
        } else {
            const tmpNewsMarketing: NewsMarketingModel[] = (news || []).filter(
                (marketing: NewsMarketingModel) => (
                    marketing.is_published === '1' && new Date() <= new Date(marketing.end_publication)
                )
            )

            if (tmpNewsMarketing.length > 0) {
                setFilteredNewsMarketing(tmpNewsMarketing.slice(0, 1))
            } else {
                setFilteredNewsMarketing([])
            }
        }
    }

    useEffect(
        () => {
            if (news.loading || (news.locale && news.locale !== intl.locale)) {
                fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getNews?language=${intl.locale}`)
                    .then(
                        (news: any) => {
                            dispatch(
                                saveNews({ ...news, locale: intl.locale })
                            )

                            filterNews(newsEnum.actualite_exploitation, news.actualite_exploitation)
                            filterNews(newsEnum.actualite_marketing, news.actualite_marketing)
                        }
                    )
                    .catch(
                        (err) => {
                            dispatch(
                                errorCatcher(err, COMPONENT_NAME)
                            )
                        }
                    )
                    .finally(
                        () => {
                            dispatch(
                                setLoadingNews(false)
                            )
                        }
                    )
            } else {
                filterNews(newsEnum.actualite_exploitation, news.actualite_exploitation)
                filterNews(newsEnum.actualite_marketing, news.actualite_marketing)
            }
        }, [dispatch, intl.locale, news]
    )

    const seeNews = () => {
        history.push(links.news)
    }

    return (
        <div>
            <div className={headerNewsClass}>
                <h1 className={classes.title3}>
                    <FormattedMessage
                        id="news.title"
                        defaultMessage="Actualités"
                        description="News title"
                    />
                </h1>
                <div className={linkAllClass}>
                    <Link
                        textStyle="text8"
                        color="colorAccessibility"
                        onClick={seeNews}
                    >
                        <FormattedMessage
                            id="news.link"
                            defaultMessage="Toutes les actualités"
                            description="News link"
                        />
                    </Link>
                </div>

            </div>

            {
                news.loading ? (
                    <Loader />
                ) : (
                    <>
                        {
                            filteredNewsExploitations.length > 0 &&
							<Exploitation
								newsExploitation={filteredNewsExploitations}
							/>
                        }
                        {
                            filteredNewsMarketing.length > 0 &&
							<Marketing
								newsMarketing={filteredNewsMarketing}
							/>
                        }
                        {
                            filteredNewsExploitations.length === 0 && filteredNewsMarketing.length === 0 &&
							<EmptyState />
                        }
                    </>
                )
            }
        </div>
    )
}

const mapStateToProps = (state: RootState) => (
    {
        news: state.news
    }
)

const mapDispatchToProps = (dispatch: Dispatch<NewsType | any>) => (
    {
        saveNews: (news: NewsModel) => {
            dispatch(saveNews(news))
        },
        errorCatcher: (error: any, id: string) => {
            dispatch(errorCatcher(error, id))
        }
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(News)
